import { Typography } from 'antd';
import { FC } from 'react';

import { BRAND_COLORS } from '../../../../../../constants/styles';

const { Text } = Typography;

export const SectionLabel: FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Text
    style={{
      color: BRAND_COLORS.secondary.lightGray,
      fontSize: 11,
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: 1,
      display: 'block',
      marginBottom: 6,
    }}
  >
    {children}
  </Text>
);
